import { Injectable } from '@angular/core';
import {NavigationEnd, NavigationStart, Router} from "@angular/router";
import {BehaviorSubject, Observable} from "rxjs";
import {ProjectArea} from "../enums/project-area";

@Injectable({
  providedIn: 'root'
})
export class ProjectAreaService {
  private readonly GAME_ENDPOINTS = ["klasse", "dashboard", "meganiceendpointforgames"];
  private readonly TEACHER_ENDPOINTS = ["lehrer"];
  private readonly PROVIDER_ENDPOINTS = ["provider"];
  private readonly ROOKIE_ENDPOINTS = ["rookie"];
  private readonly ROOKIEDAY_ENDPOINTS = ["rookieday"];

  private _currentArea = new BehaviorSubject(this.getCurrentAreaByPathname(document.location.pathname.substring(1)));

  constructor(private router: Router) {
    this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
        } else if (event instanceof NavigationEnd) {

          // console.log(event);
          let finalUrl = event.urlAfterRedirects;
          if(finalUrl.startsWith("/")) finalUrl = finalUrl.substring(1);
          // console.log(finalUrl);
          const newArea = this.getCurrentAreaByPathname(finalUrl);

          if(this._currentArea.value !== newArea) {
            this._currentArea.next(newArea);
          }
        }
      });
  }

  onAreaUpdated(): Observable<ProjectArea> {
    return this._currentArea;
  }

  getCurrentArea(): ProjectArea {
    return this._currentArea.value;
  }

  private getCurrentAreaByPathname(path: string): ProjectArea {
    for(let i = 0; i < this.GAME_ENDPOINTS.length; i++) {
      if(path.startsWith(this.GAME_ENDPOINTS[i])) {
        return ProjectArea.GAME;
      }
    }

    for(let i = 0; i < this.TEACHER_ENDPOINTS.length; i++) {
      if(path.startsWith(this.TEACHER_ENDPOINTS[i])) {
        return ProjectArea.TEACHER;
      }
    }

    for(let i = 0; i < this.PROVIDER_ENDPOINTS.length; i++) {
      if(path.startsWith(this.PROVIDER_ENDPOINTS[i])) {
        return ProjectArea.PROVIDER;
      }
    }

    for(let i = 0; i < this.ROOKIEDAY_ENDPOINTS.length; i++) {
      if(path.startsWith(this.ROOKIEDAY_ENDPOINTS[i])) {
        return ProjectArea.ROOKIEDAY;
      }
    }

    for(let i = 0; i < this.ROOKIE_ENDPOINTS.length; i++) {
      if(path.startsWith(this.ROOKIE_ENDPOINTS[i])) {
        return ProjectArea.ROOKIE;
      }
    }



    return ProjectArea.DEFAULT;
  }

}
